// Dragspel för FAQ-sidan. Gör bara något på element märkta med data-breaks-faq,
// så sidor utan FAQ-lista berörs inte. Frågorna öppnas och stängs oberoende av varandra.

import {
  AccordionSelectors,
  initAccordion,
  setAccordionItemOpen,
} from "./accordion";

const SELECTORS: AccordionSelectors = {
  item: ".breaks-faq__item",
  trigger: ".breaks-faq__trigger",
};
// Måste stämma med FaqItemExtensions.AnchorPrefix.
const ANCHOR_PREFIX = "faq-";

/** Öppnar frågan som ankaret i url:en (#faq-{id}) pekar på, och scrollar till den. */
function openFromHash(): void {
  const id = window.location.hash.slice(1);

  if (!id.startsWith(ANCHOR_PREFIX)) {
    return;
  }

  const item = document.getElementById(id);

  if (!item?.matches(SELECTORS.item) || !item.closest("[data-breaks-faq]")) {
    return;
  }

  setAccordionItemOpen(item, true, SELECTORS);
  item.scrollIntoView({ block: "start" });
}

export function initFaqs(): void {
  const lists = document.querySelectorAll<HTMLElement>("[data-breaks-faq]");

  if (lists.length === 0) {
    return;
  }

  lists.forEach((list) => initAccordion(list, SELECTORS));

  openFromHash();
  window.addEventListener("hashchange", openFromHash);
}
